(function () {
  'use strict';

  var select = document.getElementById('ErideVariantSelect');
  var priceEl = document.querySelector('[data-toc-price]');
  var configEl = document.getElementById('eride-toc-variants');
  if (!select || !priceEl || !configEl) return;

  var variants;
  try { variants = JSON.parse(configEl.textContent); } catch (e) { return; }

  function formatMoney(pence) {
    return '£' + (pence / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updatePrice(id) {
    var v = variants.find(function (x) { return String(x.id) === String(id); });
    if (!v) return;
    priceEl.textContent = formatMoney(v.price);
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
  }

  select.addEventListener('change', function () {
    updatePrice(select.value);
  });

  document.addEventListener('eride:variant-change', function (e) {
    if (e.detail && e.detail.variantId) updatePrice(e.detail.variantId);
  });
})();
